import { isAppWebView as adjustAppWebView } from '@/utils';

const isAppWebView = adjustAppWebView();

const offsetTopMixin = {
  computed: {
    tabsOffsetTop() {
      if (isAppWebView) return 0;
      return 80;
    },
  },
};

export default offsetTopMixin;
